import {
  type V2AdminNegotiationHistoryDto,
  v2AdminNegotiationsControllerHistory
} from '@idc-forms/api-client'
import { V2AdminNegotiationHistorySchema } from '@idc-forms/schemas/api-v2/admin-negotiations'
import { assertShape } from '@/shared/api/assert-shape'
import { bearer, v2RequestOptions } from '@/shared/api/v2-request'

/**
 * El historial de estados de una negociación, contra la API v2.
 *
 * Se direcciona por `neg_`, no por el `_id` de Mongo con el que trabaja el resto de la
 * pantalla: la v2 rechaza el id legacy en el pipe.
 *
 * Ojo con el nombre del símbolo generado: sale de la CLASE del controller, no de la ruta.
 */
export type NegotiationHistoryEntry = V2AdminNegotiationHistoryDto['data'][number]

export const negotiationsHistoryV2Service = {
  list: async (accessToken: string, negotiationId: string): Promise<NegotiationHistoryEntry[]> => {
    const result = await v2AdminNegotiationsControllerHistory({
      ...v2RequestOptions,
      headers: bearer(accessToken),
      path: { id: negotiationId }
    })
    return assertShape(V2AdminNegotiationHistorySchema, result.data).data
  }
}
